var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height align-start",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"pb-1"},[_c('h4',[_vm._v(_vm._s(_vm.titulo))])])],1),_c('v-row',[_c('v-col',{staticClass:"pt-0"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }